const Ranks = {
  Entry: 'entry',
  Junior: 'junior',
  Middle: 'middle',
  Senior: 'senior',
  Expert: 'expert',
}

export default Ranks
